import { ArnValidNftConfig } from '@arianee/arn-types';
import { ArnHttpService } from '../http/ArnHttpService';
import { ArnAuthService } from '../auth';
import { ArnAbstractNftService } from './ArnAbstractNftService';
import { ArnInternalNftService } from './ArnDelegateNftService';
import { ArnArianeeNftService } from './arianee/ArnArianeeNftService';
import { DefaultArianeeNftService } from './arianee/DefaultArianeeNftService';
import { DefaultErc721NftService } from './erc721/DefaultErc721NftService';
import { ArnErc721NftService } from './erc721/ArnErc721NftService';
import { ArnErc721ANftService } from './erc721a/ArnErc721ANftService';
import { DefaultErc721ANftService } from './erc721a/DefaultErc721ANftService';
import { ArnLogger } from '../log';

export class HttpNftService
  extends ArnAbstractNftService
  implements ArnInternalNftService
{
  readonly arianee: ArnArianeeNftService;
  readonly erc721: ArnErc721NftService;
  readonly erc721a: ArnErc721ANftService;

  constructor(
    readonly log: ArnLogger,
    readonly http: ArnHttpService,
    readonly auth: ArnAuthService,
    readonly config: ArnValidNftConfig
  ) {
    super();
    this.arianee = new DefaultArianeeNftService(this);
    this.erc721 = new DefaultErc721NftService(this);
    this.erc721a = new DefaultErc721ANftService(this);
  }
}
